module.exports = __webpack_public_path__ + "707d1fa0a4b42b5a15020d0df429e2f3.MP3";